export const TextSvg = () => {
  return (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0417 19.7917H16.125C16.7 19.7917 17.1667 20.2583 17.1667 20.8333C17.1667 21.4083 16.7 21.875 16.125 21.875H9.875C9.3 21.875 8.83333 21.4083 8.83333 20.8333C8.83333 20.2583 9.3 19.7917 9.875 19.7917H11.9583V5.20833H5.70833V7.29167C5.70833 7.86667 5.24167 8.33333 4.66667 8.33333C4.09167 8.33333 3.625 7.86667 3.625 7.29167V4.16667C3.625 3.59167 4.09167 3.125 4.66667 3.125H21.3333C21.9083 3.125 22.375 3.59167 22.375 4.16667V7.29167C22.375 7.86667 21.9083 8.33333 21.3333 8.33333C20.7583 8.33333 20.2917 7.86667 20.2917 7.29167V5.20833H14.0417V19.7917Z"
        fill="currentColor"
      />
    </svg>
  );
};
